;
define("site_search_button.tpl", function(){});

